module.exports = __webpack_public_path__ + "static/media/1023743.df3ff93f.png";